/**
 * Form steps script
 */
 class FinHub_FormLoginOrRegister {
    constructor () {
        this.stepAuth = $('.form-with-login-or-register .step-auth[data-url-email-exists]');

        if (this.stepAuth.length) {
            this.initEvents();
        }
    }

    initEvents () {
        this.lastStep = $('.form-with-login-or-register .form-step-with-auth');
        
        this.stepAuth.find('.btn-login').on('click', e => {
            e.preventDefault();
            this.login();
        });

        this.stepAuth.find('.btn-register').on('click', e => {
            e.preventDefault();
            this.register();
        });

        this.stepAuth.find('.register-form input[name="password"]').on('input', () => {
            if (this.stepAuth.find('.register-form input[name="password"]').val().length < 8) {
                this.stepAuth.find('.register-form .validation-error-too-short').removeClass('is-hidden');
            } else {
                this.stepAuth.find('.register-form .validation-error-too-short').addClass('is-hidden');
            }
        });

        this.stepAuth.find('.register-form input[name="password_confirmation"]').on('input', () => {
            let password = this.stepAuth.find('.register-form input[name="password"]').val();
            let passwordConfirmation = this.stepAuth.find('.register-form input[name="password_confirmation"]').val();

            if (password !== passwordConfirmation) {
                this.stepAuth.find('.register-form .validation-error-not-match').removeClass('is-hidden');
            } else {
                this.stepAuth.find('.register-form .validation-error-not-match').addClass('is-hidden');
            }
        });
    }

    showForm () {
        this.lastStep = $('.form-with-login-or-register .form-step-with-auth');

        let loader = this.lastStep.find('.step-auth-loading');
        let loginForm = this.lastStep.find('.login-form');
        let registerForm = this.lastStep.find('.register-form');
        let emailToCheck = $('.form-with-login-or-register .form-step-contact-data input[name="customer_email"]').val();

        if (loader.attr('data-checked-email') !== emailToCheck) {
            loader.removeClass('is-hidden');
            loginForm.addClass('is-hidden');
            registerForm.addClass('is-hidden');
            this.checkMail(emailToCheck);
        }
    }

    checkMail (emailToCheck) {
        let loader = this.lastStep.find('.step-auth-loading');
        let loginForm = this.lastStep.find('.login-form');
        let registerForm = this.lastStep.find('.register-form');
        let token = $('.form-with-login-or-register input[name="_token"]').val();
        this.lastStep.find('.step-auth-loading').attr('data-checked-email', emailToCheck);

        $.post(
            this.lastStep.find('.step-auth').attr('data-url-email-exists'),
            {
                email: emailToCheck,
                token: token
            },
            (result) => {
                loader.addClass('is-hidden');

                if (result.exists) {
                    loginForm.removeClass('is-hidden');
                    loginForm.find('.login-form-username').text(emailToCheck);
                    registerForm.addClass('is-hidden');
                } else {
                    loginForm.addClass('is-hidden');
                    registerForm.find('.register-form-username').text(emailToCheck);
                    registerForm.removeClass('is-hidden');
                }
            }
        );
    }

    login () {
        let email = $('.form-with-login-or-register .form-step-contact-data input[name="customer_email"]').val();
        let password = this.lastStep.find('.login-form input[name="password"]').val();
        let loader = this.lastStep.find('.step-auth-loading');
        loader.removeClass('is-hidden');

        $.post(
            this.stepAuth.find('.login-form ').attr('data-url'),
            {
                email: email,
                password: password
            }
        ).done((result) => {
            loader.addClass('is-hidden');
            
            if (result.id) {
                this.submitMainForm();
            } else {
                loader.addClass('is-hidden');
                $('.login-form .validation-error').removeClass('is-hidden');

                this.lastStep.find('.login-form input[name="password"]').one('input', () => {
                    $('.login-form .validation-error').addClass('is-hidden');
                });

                console.log(result);
            }
        }).fail((result) => {
            loader.addClass('is-hidden');
            $('.login-form .validation-error').removeClass('is-hidden');

            this.lastStep.find('.login-form input[name="password"]').one('input', () => {
                $('.login-form .validation-error').addClass('is-hidden');
            });
            
            console.log(result);
        });
    }

    register () {
        let email = $('.form-with-login-or-register .form-step-contact-data input[name="customer_email"]').val();
        let password = this.lastStep.find('.register-form input[name="password"]').val();
        let password_confirmation = this.lastStep.find('.register-form input[name="password_confirmation"]').val();
        let loader = this.lastStep.find('.step-auth-loading');
        let name = $('.form-with-login-or-register .form-step-contact-data input[name="customer_name"]').val();
        let surname = $('.form-with-login-or-register .form-step-contact-data input[name="customer_surname"]').val();
        let phone = $('.form-with-login-or-register .form-step-contact-data input[name="customer_phone"]').val();
        let city = $('.form-with-login-or-register .form-step-contact-data input[name="customer_city"]').val();
        let post_code = $('.form-with-login-or-register .form-step-contact-data input[name="customer_post_code"]').val();
        let accepted_regulations = $('.form-with-login-or-register .form-step-contact-data input[name="customer_accepted_terms_and_policy_privacy"]').val();
        let accepted_policy_privacy = $('.form-with-login-or-register .form-step-contact-data input[name="customer_contact_adviser_agreement"]').val();
        let contact_agreement = $('.form-with-login-or-register .form-step-contact-data input[name="customer_contact_finhub_agreement"]').val();
        let registerForm = this.stepAuth.find('.register-form');

        if (password.length < 8) {
            registerForm.find('.validation-error-too-short').removeClass('is-hidden');
            return;
        }

        if (password !== password_confirmation) {
            registerForm.find('.validation-error-not-match').removeClass('is-hidden');
            return;
        }

        loader.removeClass('is-hidden');

        $.post(
            registerForm.attr('data-url'),
            {
                email: email,
                password: password,
                password_confirmation: password_confirmation,
                name: name, 
                surname: surname, 
                phone: phone,
                accepted_terms_and_policy_privacy: accepted_regulations, 
                contact_adviser_agreement: accepted_policy_privacy, 
                contact_finhub_agreement: contact_agreement,
                city: city,
                post_code: post_code
            }
        ).done((result) => {
            loader.addClass('is-hidden');
            
            if (result.data.customer_id) {
                if ($('.form-with-login-or-register input[name="customer_id"]').length) {
                    $('.form-with-login-or-register input[name="customer_id"]').val(result.data.customer_id);
                } else {
                    let customerIdField = $('<input type="hidden" name="customer_id" />');
                    customerIdField.val(result.data.customer_id);
                    customerIdField.appendTo($('.form-with-login-or-register'));
                }

                setTimeout(() => {
                    this.submitMainForm();
                }, 0);
            } else {
                loader.addClass('is-hidden');
                $('.register-form .validation-error-common-error').removeClass('is-hidden');
                console.log(result);
            }
        }).fail((result) => {
            loader.addClass('is-hidden');
            $('.register-form .validation-error-common-error').removeClass('is-hidden');
            console.log(result);
        });
    }

    submitMainForm () {
        let form = $('.form-with-login-or-register');
        form.find('.login-form').remove();
        form.find('.register-form').remove();

        $.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: form.serialize()
        }).done ((data) => {
            console.log(data);
            $('.form-step-summary').removeClass('is-hidden');
            $('.wrapper[data-current-step]').addClass('is-sent-successfully');

            if (data.adviser) {
                $('.form-step-summary').find('.advisor-image img').attr('src', data.adviser.image_url);
                $('.form-step-summary').find('.advisor-name').text(data.adviser.name + ' ' + data.adviser.surname);
                $('.form-step-summary').removeClass('is-hidden');
                $('.wrapper[data-current-step]').addClass('is-sent-successfully');
            }
        }).fail((result) => {
            console.log('FAIL', result);
        });
    }
}
